import { getAxiosInstance } from '../../react/utils/networkUtil';

// Geocoding
export type Map_Geocoding_Request = {
  lat: number;
  lng: number;
};
export const remote_geocoding = async (request: Map_Geocoding_Request): Promise<any> => {
  return (
    await getAxiosInstance({
      hideSystemError: true,
    }).get('/api/map-ext/geocoding', {
      params: {
        lat: request.lat,
        lng: request.lng,
      },
      timeout: 3000,
    })
  ).data;
};
// End geocoding

// Forward geocoding
type AddressComponent = {
  long_name: string;
  short_name: string;
};

type Geometry = {
  location: {
    lat: number;
    lng: number;
  };
  boundary: null | any; // Adjust type if boundary has a specific structure
};

type PlusCode = {
  compound_code: string;
  global_code: string;
};

type Compound = {
  district: string;
  commune: string;
  province: string;
};
export type Map_ForwardGeocoding_ResponseItem = {
  address: string;
  address_components: AddressComponent[];
  compound: Compound;
  formatted_address: string;
  geometry: Geometry;
  name: string;
  place_id: string;
  plus_code: PlusCode;
  reference: string;
  types: string[];
};
export type Map_ForwardGeocoding_Request = {
  address: string;
  limit?: number;
};
export type Map_ForwardGeocoding_Response = {
  results: Map_ForwardGeocoding_ResponseItem[];
  status: string;
};
export const remote_forwardGeocoding = async (
  request: Map_ForwardGeocoding_Request,
): Promise<Map_ForwardGeocoding_Response> => {
  return (
    await getAxiosInstance({
      hideSystemError: true,
    }).get('/api/map-ext/forward-geocoding', {
      params: {
        address: request.address,
      },
    })
  ).data;
};
// End forward geocoding

// Get Place Detail
export type Map_GetPlaceDetail_Request = {
  place_id: string;
};
export const remote_getPlaceDetail = async (request: Map_GetPlaceDetail_Request): Promise<any> => {
  return (
    await getAxiosInstance().get('/api/map-ext/get-place-detail', {
      params: {
        place_id: request.place_id,
      },
    })
  ).data;
};
// End Get place detail

export const MapAPIs = {
  remote_geocoding,
  remote_forwardGeocoding,
  remote_getPlaceDetail,
};
